var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":`0 0 ${_vm.metrics.width} ${_vm.metrics.height}`,"height":_vm.size}},[_c('path',{attrs:{"fill":_vm.fill,"stroke":_vm.stroke,"d":_vm.d}})])
}
var staticRenderFns = []

export { render, staticRenderFns }